<template >
  <div>
    <Toast  />
    <router-view  />    
  </div>
</template>

<script>
  export default {
  }
</script>